export default __webpack_public_path__ + "974f2df242a168ed163cf7c41019cf76.svg";